import React from "react";
import { motion } from "framer-motion";
import { Sun, Droplet, Scissors, Layers } from "lucide-react";

const container = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.25 },
  },
};

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

export default function Cosmetics() {
  return (
    <div className="w-full">
      {/* Hero Banner */}
      <div
        className="relative h-[300px] md:h-[400px] w-full bg-cover bg-center flex items-center justify-center"
        style={{
          backgroundImage:
            "url('/images/cosmetics-banner.webp')",
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <h1 className="relative text-4xl md:text-5xl font-bold text-white text-center">
          Cosmetics & Personal Care
        </h1>
      </div>

      {/* Content Section with Motion */}
      <motion.div
        className="max-w-6xl mx-auto px-4 py-12"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={container}
      >
        {/* Intro */}
        <motion.p className="text-lg text-gray-700 mb-10" variants={fadeInUp}>
          At <span className="font-semibold text-[#0d47a1]">MAC LABS LTD</span>, we
          blend science with beauty by providing high-quality cosmetic actives and
          specialty ingredients that empower the creation of safe, effective, and
          innovative personal care solutions. Our portfolio supports a wide range of
          applications, from sun protection and skin care to hair care and wellness
          formulations, ensuring performance without compromising on safety.
        </motion.p>

        {/* Focus Areas */}
        <motion.h2 className="text-2xl font-bold text-gray-800 mb-6" variants={fadeInUp}>
          Our Focus Areas
        </motion.h2>
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {/* Animated Cards */}
          <motion.div
            className="p-6 border rounded-lg shadow-sm bg-white transition"
            variants={fadeInUp}
            whileHover={{
              scale: 1.06,
              boxShadow: "0px 8px 24px rgba(13,71,161,0.08)",
            }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
          >
            <Sun className="w-8 h-8 text-yellow-500 mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Sun Care</h3>
            <p className="text-gray-600">
              Advanced UV filters and sunscreen agents designed to deliver superior
              protection and stability.
            </p>
          </motion.div>
          <motion.div
            className="p-6 border rounded-lg shadow-sm bg-white transition"
            variants={fadeInUp}
            whileHover={{
              scale: 1.06,
              boxShadow: "0px 8px 24px rgba(13,71,161,0.08)",
            }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
          >
            <Droplet className="w-8 h-8 text-blue-500 mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Skin Care</h3>
            <p className="text-gray-600">
              Ingredients that enhance radiance, provide antioxidant support, and
              promote healthy, nourished skin.
            </p>
          </motion.div>
          <motion.div
            className="p-6 border rounded-lg shadow-sm bg-white transition"
            variants={fadeInUp}
            whileHover={{
              scale: 1.06,
              boxShadow: "0px 8px 24px rgba(13,71,161,0.08)",
            }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
          >
            <Scissors className="w-8 h-8 text-purple-500 mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Hair Care</h3>
            <p className="text-gray-600">
              Specialized actives including anti-dandruff and scalp care solutions.
            </p>
          </motion.div>
          <motion.div
            className="p-6 border rounded-lg shadow-sm bg-white transition"
            variants={fadeInUp}
            whileHover={{
              scale: 1.06,
              boxShadow: "0px 8px 24px rgba(13,71,161,0.08)",
            }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
          >
            <Layers className="w-8 h-8 text-green-500 mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Multi-Functional Agents</h3>
            <p className="text-gray-600">
              Versatile ingredients tailored for modern cosmetic formulations.
            </p>
          </motion.div>
        </div>

        {/* Closing */}
        <motion.p className="text-gray-700 font-medium" variants={fadeInUp}>
          With our Cosmetic solutions,{" "}
          <span className="font-semibold">MAC LABS LTD</span> empowers brands to
          create innovative, safe, and effective personal care products that meet
          global standards and consumer expectations.
        </motion.p>
      </motion.div>
    </div>
  );
}
